import React, { FC, memo, useCallback, useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import ToolBar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import logo from "../../assets/logo.png";
import noAvatorIcon from "../../assets/noAvatar.png";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

import Tooltip from "@mui/material/Tooltip";
import { useLocation } from "react-router-dom";
import classes from "./Header.module.scss";

import { Divider, IconButton, Menu, MenuItem } from "@mui/material";
import { useRecoilValue } from "recoil";
import { userState } from "../../states/userState";
import { useLogout } from "../../hooks/useLogout";
import { theme } from "../../commons/theme";
import SwitchMode from "../uikit/atoms/SwitchMode";

export const Header = (props) => {
  const { pageTitle } = props;
  const user = useRecoilValue(userState);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menu, setMenu] = useState();
  const [sideBarOpenDeparment, setSideBarOpenDepartment] = useState(false);
  const { logoutFromGoogleWithResetCache } = useLogout();
  const handleLogoClick = (e) => {
    //スクロールする処理を記述
    try {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    } catch (error) {
      // just a fallback for older browsers
      window.scrollTo(0, 0);
    }
  };

  const handleMenu = (event) => {
    if (user?.isAuth) {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleClickLogOut = () => {
    logoutFromGoogleWithResetCache();
    handleClose();
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div className={classes.header}>
      <AppBar position="fixed" className={classes.menuBar}>
        <ToolBar className={classes.toolBar}>
          <img
            src={logo}
            alt="Logo"
            className={classes.logo}
            // onClick={(e) => handleLogoClick(e, true)}
            onClick={(e) => handleLogoClick(e, true)}
          />

          <Typography
            variant="h6"
            component="div"
            className={classes.pageTitle}
            style={color(user?.mode ?? "dark")}
          >
            {pageTitle}
          </Typography>

          <div className={classes.rightMenuIcons}>
            <div className={classes.vDivider} />
            <div className={classes.userArea}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
              >
                <Typography
                  variant="body1"
                  component="div"
                  className={classes.userName}
                  style={color(user?.mode ?? "dark")}
                >
                  {user?.isAuth ? user?.workerName : ""}
                </Typography>
                <img
                  src={user?.isAuth ? user?.photoURL : noAvatorIcon}
                  alt=""
                  className={classes.noAvatorIcon}
                />
              </IconButton>
            </div>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              // sx={{ backgroundColor: "black" }}
              sx={{
                "& .MuiPaper-root": {
                  // Paperコンポーネントに対するスタイル
                  backgroundColor: "#202226",
                },
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingLeft: "10px",
                  // backgroundColor: "black",
                }}
              >
                {/* <ListItemIcon> */}
                <ExitToAppIcon style={color(user?.mode ?? "dark")} />
                {/* </ListItemIcon> */}
                <MenuItem
                  onClick={handleClickLogOut}
                  className={classes.logout}
                  style={color(user?.mode ?? "dark")}
                >
                  ログアウト
                </MenuItem>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                  marginRight: "20px",
                }}
              >
                <MenuItem style={color(user?.mode ?? "dark")}>モード</MenuItem>
                <SwitchMode />
              </div>
            </Menu>
          </div>
        </ToolBar>
        {/* //要素を追加 */}
      </AppBar>
    </div>
  );
};
const color = (mode) => {
  return {
    color:
      mode === "lite"
        ? theme.palette.liteColor.foreColor.main //間違いではない。色合いを考慮してdarkColorを指定している
        : theme.palette.darkColor.foreColor.main,
  };
};
